import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/img/logo/logo.png")